// Analytics utility for Google Analytics 4 and Facebook Pixel

// Initialize Google Analytics 4
export const initGA4 = (measurementId) => {
  if (typeof window === 'undefined' || !measurementId) return;
  
  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
  
  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  
  gtag('js', new Date());
  gtag('config', measurementId);
  
  console.log('✅ Google Analytics 4 initialized:', measurementId);
};

// Initialize Facebook Pixel
export const initFacebookPixel = (pixelId) => {
  if (typeof window === 'undefined' || !pixelId) return;
  
  // Facebook Pixel Code
  !function(f,b,e,v,n,t,s) {
    if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)
  }(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  
  console.log('✅ Facebook Pixel initialized:', pixelId);
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
  
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', eventName, eventParams);
  }
  
  console.log('📊 Event tracked:', eventName, eventParams);
};

// Track page view
export const trackPageView = (pagePath) => {
  if (window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA4_MEASUREMENT_ID, {
      page_path: pagePath
    });
  }
  
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// E-commerce tracking for checkout
export const trackCheckoutStarted = ({ plan, currency, value }) => {
  trackEvent('begin_checkout', {
    currency: currency,
    value: value,
    items: [{
      item_id: plan,
      item_name: `Hero ${plan}`,
      item_category: 'Subscription',
      price: value,
      quantity: 1
    }]
  });
};

// Track successful purchase
export const trackPurchase = ({ transactionId, plan, currency, value }) => {
  // Google Analytics GA4
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: transactionId,
      value: value,
      currency: currency,
      items: [{
        item_id: plan,
        item_name: `Hero ${plan}`,
        item_category: 'Subscription',
        price: value,
        quantity: 1
      }]
    });
    
    // Google Ads Conversion Tracking
    window.gtag('event', 'conversion', {
      'send_to': 'AW-668370388/conversion_label_here', // Update with your conversion label
      'value': value,
      'currency': currency,
      'transaction_id': transactionId
    });
  }
  
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      value: value,
      currency: currency,
      content_name: `Hero ${plan}`,
      content_type: 'product'
    });
  }
};

// Track lead capture
export const trackLead = ({ email, plan }) => {
  trackEvent('generate_lead', {
    email: email,
    plan: plan
  });
};

// Track button clicks
export const trackButtonClick = (buttonName) => {
  trackEvent('button_click', {
    button_name: buttonName
  });
};
